import ApplicationSerializer from 'eflex/serializers/application';

export default class WieConfigEditorDefaultsSerializer extends ApplicationSerializer {
  attrs = {
    normal: {
      embedded: 'always',
    },
    text: {
      embedded: 'always',
    },
    lines: {
      embedded: 'always',
    },
    shape: {
      embedded: 'always',
    },
    image: {
      embedded: 'always',
    },
    icons: {
      embedded: 'always',
    },
  };
}
